import React from 'react';
import PropTypes from 'prop-types';
import cssReset from './cssReset';
import { selectSystemProps, a11yProps, htmlAttrs } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
const [selectProps, selectedSystemPropTypes] = selectSystemProps([a11yProps, htmlAttrs]);

/**
 * On Web, wraps children with a HTML `<fieldset>` and sets its attributes as necessary.
 */
const FieldsetContainer = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    inactive,
    accessibilityRole,
    name: fieldsetName,
    showBorderStyle = false,
    borderStyle,
    style,
    ...rest
  } = _ref;
  // If needs border for error design or reset the component style
  const styleContainer = showBorderStyle && borderStyle ? borderStyle : cssReset;
  return /*#__PURE__*/_jsx("fieldset", {
    ref: ref,
    disabled: inactive,
    style: {
      ...styleContainer,
      ...style
    },
    role: accessibilityRole,
    name: fieldsetName,
    ...selectProps(rest),
    children: children
  });
});
FieldsetContainer.displayName = 'FieldsetContainer';
FieldsetContainer.propTypes = {
  ...selectedSystemPropTypes,
  accessibilityRole: PropTypes.string,
  children: PropTypes.node,
  inactive: PropTypes.bool,
  name: PropTypes.string,
  showBorderStyle: PropTypes.bool,
  borderStyle: PropTypes.object,
  style: PropTypes.object
};
export default FieldsetContainer;